app.service('searchService', function ($http, $rootScope) {
  let googleAddressKeys = ['street_number', 'route', 'neighborhood', 'locality', 'administrative_area_level_2', 'administrative_area_level_1', 'country', 'postal_code', 'postal_code_suffix']
  let googleKeyConversion = ['street_number', 'street_name', 'neighborhood', 'city', 'county', 'state', 'country', 'zip', 'zip_suffix']
  let googleCounties = []
  let countyCodes = []
  let countylist = []
  let _newCounties = null
  let searchMethod = 1

  this.searchLevenshtein = function (obj) {
    return $http.post('/properties/searchLevenshtein', obj)
      .then(function (response) {
        return response
      })
  }

  this.performAnalysis = function (obj) {
    return $http.post('/properties/performAnalysis', obj)
      .then(function (response) {
        return response
      })
  }

  this.getPropUID = function (obj) {
    return $http.post('/properties/getPropUID', obj)
      .then(function (response) {
        return response
      })
  }

  this.getTaxIDs = function (obj) {
    return $http.post('/properties/gettaxids', obj)
      .then(function (response) {
        return response
      })
  }

  this.getStreets = function (obj) {
    return $http.post('/properties/getStreets', obj)
      .then(function (response) {
        return response
      })
  }


  this.setSearchMethod = function (mode) {
    searchMethod = mode
  }
  this.getSearchMethod = function () {
    return searchMethod
  }

  this.getCountyList = function () {
    return countylist
  }
  this.getNewCountyList = function () {
    return _newCounties
  }


  this.setGoogleCounties = (obj) => {
    countylist = []
    googleCounties = []
    countyCodes = []
    obj.map(item => {
      googleCounties.push(item.name)
      countyCodes.push(item.cad_code)
      countylist.push(item.county)
    })
    return countylist.join(", ")
  }

  this.convertGoogleResponseToObject = function (place) {
    if (!place || !place.address_components) return { cad_code: '000' }
    let retObj = {}
    const addressInfo = place.address_components
    // Build Address Obj
    addressInfo.forEach((component) => {
      const keyPosition = googleAddressKeys.indexOf(component.types[0])
      if (keyPosition > -1) {
        retObj[googleKeyConversion[keyPosition]] = component
      }
    })
    // Get Formatted Address
    if (place.formatted_address) {
      retObj.formatted_address = place.formatted_address.replace(", USA", "")
    }
    // Get County Name & County Code

    if (retObj.county?.long_name) {
      const fullCountyName = retObj.county.long_name
      retObj.county_name = fullCountyName.replace(" County", "")

      console.log('googleCounties :>> ', googleCounties);
      console.log('countyCodes :>> ', countyCodes);

      // $rootScope.cadNames and $rootScope.cadCodes are defined in app.js
      // --------------------------------------------------------------------------------
      let newCounties = $rootScope.cadNames.split(',').map(county => county.trim())
      let newCadcodes = $rootScope.cadCodes.split(',').map(cadcode => cadcode.trim())
      googleCounties.push(...newCounties)
      countyCodes.push(...newCadcodes)

      const countyIndex = googleCounties.indexOf(fullCountyName)
      retObj.cad_code = countyIndex > -1 ? String(countyCodes[countyIndex]) : '000'
    } else {
      retObj.cad_code = '000';
    }
    // console.log('retObj :>> ', retObj);
    return retObj
  }

})
